import { render, staticRenderFns } from "./UploadAsnModal.vue?vue&type=template&id=013c350e"
import script from "./UploadAsnModal.vue?vue&type=script&lang=ts"
export * from "./UploadAsnModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports